import {
    getField,
    updateField
} from "vuex-map-fields"
import {requestCreate} from "../../api"
import {
    ADD_ROW, RESET_FORM
} from "../../constant-types"

const getDefaultState = () => {
    return {
        rows: [getDefaultRowState()]
    }
}

const getDefaultRowState = () => ({
    id: '',
    transfer_date: (new Date()).toISOString().split('T')[0],
    ref_stock_warehouse : null, // ref
    from_warehouse_id: '',
    to_warehouse_id: '',
    product_id: '',
    product: null, // for reference
    qty: 1,
    memo: '',
    // created_by_id: '' // applied on backend
})

export default ({
    namespaced: true, 
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_ROW](state) {
            state.rows.push(getDefaultRowState())
        },
        [RESET_FORM](state) {
            Object.assign(state, getDefaultState())
        },
        updateField

    },
    // can async
    actions: {
        requestCreateTransfer({commit, state }) {
            return requestCreate('stock-transfer', state.rows[0], commit, '', undefined, undefined, (successResponse) => {
                // add to list
                commit('stockTransfer/ADD_TO_LIST', successResponse, { root : true })
                // clean form
                commit(RESET_FORM)
            })
        }
    },
    // call variable with custom display
    getters: {
        getField
    }
})
